export default __webpack_public_path__ + "static/iliberty-8e281986067b79461722c6aa3f9e8076.png";